import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useModalRouter from 'hooks/useModalRouter';

import ImportDataModal from 'modals/ImportDataModal';

import { importActions } from 'pages/Settings/ImportExport/ImportLog/ImportLogList';

import { ENUMS, WAREHOUSES } from 'services/consts';

import { setListMapView } from 'stores/layoutSlice';

import { DYNAMICLISTS } from 'utils/constants';

import { faDownload, faList, faLocationDot, faPlus } from '@fortawesome/pro-solid-svg-icons';

const WarehouseList = () => {
	const listMapView = useSelector((state) => state.layout.listMapView);
	const dispatch = useDispatch();

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', width: 60, filterType: FilterType.number, show: false },
			{
				Header: 'warehouseName',
				accessor: 'name',
				width: 110,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WAREHOUSES,
				showOnMobile: true,
				showOnMap: true
			},
			{ Header: 'warehouseCode', accessor: 'code', width: 70, filterType: FilterType.string },
			{
				Header: 'operationalHours',
				accessor: 'workingHourJSON',
				width: 200,
				filterType: FilterType.string,
				renderCell: ListComponents.CHIP_VIEWER
			},
			{
				Header: 'mobileNumber',
				accessor: 'phone',
				width: 120,
				filterType: FilterType.string,
				renderCell: ListComponents.PHONE,
				showOnMap: true
			},
			{ Header: 'city', accessor: 'cityName', width: 80, filterType: FilterType.multiSelection },
			{
				Header: 'country',
				accessor: 'countryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 80,
				show: false
			},
			{ Header: 'address', accessor: 'address', width: 140, filterType: FilterType.string, showOnMap: true },
			{
				Header: 'servingRadius',
				accessor: 'servingRadius',
				filterType: FilterType.float,
				showOnMap: true
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				width: 100,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_INACTIVE,
				showOnMobile: true
			},
			{
				Header: 'storeName',
				accessor: 'storeName',
				width: 100,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.BRAND_NAME,
				show: false,
				renderCell: ListComponents.BRAND_LOGO,
				roleName: 'BrandingModule'
			},
			{ Header: 'latitude', accessor: 'lat', width: 100, filterType: FilterType.string, show: false },
			{ Header: 'longitude', accessor: 'lng', width: 100, filterType: FilterType.string, show: false },
			{
				Header: 'email',
				accessor: 'email',
				width: 140,
				filterType: FilterType.string,
				show: false,
				showOnMap: true
			}
		],
		[]
	);

	const { showModal } = useModalRouter();
	return (
		<div>
			<PageHeader
				title="warehouses"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/warehouse-icon.json.gz"
				moduleName="warehouse-module">
				<Button
					icon={listMapView ? faList : faLocationDot}
					label={listMapView ? 'listView' : 'Mapview'}
					onClick={() => dispatch(setListMapView(!listMapView))}
					variant="borderless"
					className="mobile-hidden"
				/>

				<Authorization path="/import-export/button/warehouseImport">
					<Button
						className="mobile-hidden importDataButton"
						icon={faDownload}
						variant="borderless"
						label="uploadWarehouse"
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
						onClick={() => NiceModal.show(ImportDataModal, importActions.warehouseImport)}
					/>
				</Authorization>

				<Authorization path="/modal/warehouse-form">
					<Button
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						id="WarehouseInstruction1"
						icon={faPlus}
						label="addWarehouse"
						onClick={() => showModal('warehouse-form')}
						variant="blue"
						className="addButton"
					/>
				</Authorization>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.WAREHOUSES}
				columns={columns}
				fetchUrl={WAREHOUSES.GET_WAREHOUSE_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.WAREHOUSE}
				exportName="warehouses"
				showMapViewButton
			/>
		</div>
	);
};

export default WarehouseList;
